export default {
  unnamed: '(no name)',
  sumShort: 'sum per period',
  meanShort: 'average per period',
  total: 'Total',
  average: 'Average',
  noData: 'No data in this selection',
  noDataPeriod: 'No data'
}
